import * as React from 'react';
export const FeatureAppContext = React.createContext(undefined);
//# sourceMappingURL=feature-app-context.js.map